<script setup>
defineProps({
    links: { type: Array, required: true },
    lastPage: { type: Number, required: true },
})
</script>

<template>
    <nav
        class="mt-16 flex flex-wrap gap-2"
        v-if="lastPage > 1"
        aria-label="Stránkování"
    >
        <template
            v-for="link in links"
            :key="link.label"
        >
            <Link
                class="rounded-md px-4 py-2 text-sm font-semibold transition-colors"
                v-if="link.url"
                v-html="link.label"
                :href="link.url"
                :class="link.active ? 'bg-brand-900 text-white' : 'text-brand-900 hover:bg-zinc-100'"
            />

            <span
                class="rounded-md px-4 py-2 text-sm font-semibold text-zinc-400"
                v-else
                v-html="link.label"
            />
        </template>
    </nav>
</template>
